import styled from 'styled-components';

export const StyledList = styled.ol`
  margin-left: 16px;
  margin: 0;
  font-weight: normal;
  line-height: 2;
  text-align: left;
`;
